import * as React from 'react';
import { createComponent } from '@lit/react';
import { DataTableWC, DataTableRowSelection } from './data-table.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../component-types-generics';

export type DataTableProps<Q> = GenerateComponentTypeWithChildren<
  DataTableWC<Q>
> & {
  onRowSelectionChange?: (event: DataTableRowSelection<Q>) => void;
};

export type DataTablePropsPropsWithRef<R> = GeneratePropsWithRef<
  DataTableProps<R>
>;

// Created once at module level so React reuses the same component class
// across renders — prevents the web component from unmounting/remounting
// on every re-render which caused icon flickering.
const DataTableComponent = createComponent({
  tagName: DataTableWC.tagname,
  elementClass: DataTableWC,
  react: React,
  events: {
    onRowSelectionChange: 'row-selection-change',
  },
});

function DataTableInput<T>(props: DataTableProps<T>, ref: unknown) {
  const DynamicDataTable = DataTableComponent as DataTablePropsPropsWithRef<T>;

  return <DynamicDataTable ref={ref as typeof DynamicDataTable} {...props} />;
}

export const DataTable = React.forwardRef(DataTableInput) as <T>(
  // eslint-disable-next-line no-use-before-define
  p: DataTableProps<T> & { ref?: React.Ref<DataTableWC> }
) => React.ReactElement;
